import React from 'react'

import { MintButton } from '../../styles/PageLayout'

const BtnMintThree = ({ className, ...props }) => (
  <MintButton
    width="43"
    height="45"
    viewBox="0 0 43 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <rect x="0.5" y="0.5" width="42" height="44" fill="white" stroke="#591ED8" />
    <path
      d="M15.8686 28.2374V23.8433H14.8447V29.3356H25.0828V28.2374H23.0351H15.8686Z"
      fill="#591ED8"
    />
    <path
      d="M25.0832 32.6316H14.8451V29.3359H13.8213V33.7301H26.1071V29.3359H25.0832V31.533V32.6316Z"
      fill="#591ED8"
    />
    <path d="M15.8686 15.0552H14.8447V16.1537H15.8686V15.0552Z" fill="#591ED8" />
    <path d="M14.8451 12.8584H13.8213V15.0555H14.8451V12.8584Z" fill="#591ED8" />
    <path
      d="M20.9883 13.957H17.9168V15.0556H19.9645V19.4494H17.9168V15.0556H16.893V16.1541H15.8691V17.2523H16.893V19.4494H17.9168V20.5479H19.9645V19.4494H20.9883V17.2523V13.957Z"
      fill="#591ED8"
    />
    <path
      d="M27.1315 16.1541V15.0556H26.1076V19.4494H24.06V15.0556H26.1076V13.957H23.0361V19.4494H24.06V20.5479H26.1076V19.4494H27.1315V18.3509H28.1553V17.2523H27.1315V16.1541Z"
      fill="#591ED8"
    />
    <path d="M29.1791 16.1538H28.1553V17.2523H29.1791V16.1538Z" fill="#591ED8" />
    <path d="M30.2026 15.0552H29.1787V16.1537H31.2264V15.0552H30.2026Z" fill="#591ED8" />
    <path
      d="M31.226 16.1538V19.4491H30.2021V20.5476H31.226V19.4491H32.2495V16.1538H31.226Z"
      fill="#591ED8"
    />
    <path d="M30.2026 20.5479H29.1787V21.6464H30.2026V20.5479Z" fill="#591ED8" />
    <path d="M29.1791 21.6465H28.1553V22.745H29.1791V21.6465Z" fill="#591ED8" />
    <path d="M28.1547 22.7446H27.1309V23.8432H28.1547V22.7446Z" fill="#591ED8" />
    <path d="M26.1074 24.9418V26.0403H27.1313V23.8433H26.1074V24.9418Z" fill="#591ED8" />
    <path d="M25.083 27.1391V28.2376H26.1068V26.0405H25.083V27.1391Z" fill="#591ED8" />
    <path d="M14.8451 20.5479H13.8213V23.8435H14.8451V21.6464V20.5479Z" fill="#591ED8" />
    <path d="M13.8217 19.4492H12.7979V20.5478H13.8217V19.4492Z" fill="#591ED8" />
    <path
      d="M12.7973 18.3506V19.4491H13.8211V18.3506H12.7973V16.1538H11.7734V18.3506H12.7973Z"
      fill="#591ED8"
    />
    <path d="M10.75 13.9569V16.154H11.7735V12.8584H10.75V13.9569Z" fill="#591ED8" />
    <path d="M12.7973 11.7598H11.7734V12.8583H13.8211V11.7598H12.7973Z" fill="#591ED8" />
    <path d="M23.035 12.8584H20.9873V13.9569H23.035V12.8584Z" fill="#591ED8" />
    <path d="M23.035 19.4492H20.9873V20.5478H23.035V19.4492Z" fill="#591ED8" />
  </MintButton>
)

export default BtnMintThree
